<div class="dialog">
    <div class="content">
        <div class="phone-img">
            <img src="assets/images/phone.png" alt="Phone Icon">
        </div>
        <div class="text">
            <p>This request has been rejected by you</p>
        </div>
    </div>
    <div class="btn">
        <button class="btn-retry" (click)="onRenew()">Renew QR</button>
    </div>
</div>